import { OrbitMotif } from '../ui/OrbitMotif';
import { OrbitNode } from '../ui/OrbitNode';
import { SectionLabel } from '../ui/SectionLabel';
import { usePointerTilt } from '../../hooks/usePointerTilt';
import { site } from '../../data/site';

export function Hero() {
  const figureRef = usePointerTilt<HTMLDivElement>();

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="wrap hero-inner">
        <div className="hero-copy" data-reveal>
          <SectionLabel variant="eyebrow">
            {site.name.replace(' (Pty) Ltd', '')}
          </SectionLabel>
          <h1 id="hero-title">Engineering for complex, high-reliability systems.</h1>
          <p className="lede">
            ADCS combines control engineering, simulation, embedded software and
            systems integration to take demanding ideas from first principles to
            verified implementation.
          </p>
          <p className="hero-actions">
            <a className="btn btn-primary" href="#services">
              Explore our capabilities
            </a>
            <a className="btn btn-quiet" href="#contact">
              Discuss a project
            </a>
          </p>
        </div>

        <div className="hero-figure" aria-hidden="true" data-reveal ref={figureRef}>
          <OrbitMotif />
          <OrbitNode />
        </div>
      </div>
    </section>
  );
}
